/*
 * @author Oleksandr Papka <papkaos>
 */
angular.module('popup.report', [
  'popup'
]);